import React from "react";
import "./FooterSection.css";
import logo from "../assets/mindstreamx-logo.png";

import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaArrowRight,
  FaArrowUp,
} from "react-icons/fa";

const QUICK_LINKS = [
  { name: "Home", href: "/" },
  { name: "About Us", href: "/about-us" },
  { name: "Services", href: "/services" },
  { name: "Portfolio", href: "/portfolio" },
  // { name: "Technologies", href: "/#technologies" },
  { name: "Contact Us", href: "/contact" },
];

const SERVICES_LINKS = [
  { name: "Enterprise Solutions", href: "/services" },
  { name: "SaaS Solutions", href: "/services" },
  { name: "IT Consulting", href: "/services" },
  { name: "Lead Management System", href:"lead-management" },
  { name: "Payment Orchestrator", href: "/portfolio" },
  {
    name: "Healthcare Management System",
    href: "/portfolio",
  },
];

const CONTACT_INFO = [
  {
    icon: <FaMapMarkerAlt />,
    text: (
      <>
        Thrissur, Kerala
        <br />
        India
      </>
    ),
  },
  {
    icon: <FaPhoneAlt />,
    text: "+91 8891203931",
    href: "tel:+918891203931",
  },
  {
    icon: <FaEnvelope />,
    text: "sales@mindstreamx.com",
    href: "mailto:sales@mindstreamx.com",
  },
  // {
  //   icon: <FaGlobe />,
  //   text: "www.mindstreamx.com",
  //   href: "https://www.mindstreamx.com",
  // },
];

const FooterSection = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="footer-section">
      <div className="footer-container">
        {/* COLUMN 1 - BRAND */}
        <div className="footer-col brand-col">
          <div className="footer-logo">
            <img
              src={logo}
              alt="MindstreamX Technologies"
              className="footer-logo-image"
            />
          </div>
          <p className="brand-desc">
            Building intelligent solutions for a smarter, connected tomorrow.
          </p>

          <div className="signature-text">Let's Build Together</div>
        </div>

        {/* COLUMN 2 - QUICK LINKS */}
        <div className="footer-col links-col">
          <h3>Quick Links</h3>
          <ul className="footer-links">
            {QUICK_LINKS.map((link, index) => (
              <li key={index}>
                <a href={link.href}>
                  <FaArrowRight className="link-arrow" />
                  <span>{link.name}</span>
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* COLUMN 3 - SERVICES */}
        <div className="footer-col links-col services-col">
          <h3>Our Services</h3>
          <ul className="footer-links">
            {SERVICES_LINKS.map((link, index) => (
              <li key={index}>
                <a href={link.href}>
                  <FaArrowRight className="link-arrow" />
                  <span>{link.name}</span>
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* COLUMN 4 - CONTACT */}
        <div className="footer-col contact-col">
          <h3>Contact Us</h3>
          <ul className="contact-list">
            {CONTACT_INFO.map((item, index) => (
              <li key={index}>
                <span className="contact-icon">{item.icon}</span>
                {item.href ? (
                  <a href={item.href} className="contact-link">
                    {item.text}
                  </a>
                ) : (
                  <span className="contact-text">{item.text}</span>
                )}
              </li>
            ))}
          </ul>
        </div>

        {/* COLUMN 5 - CTA */}
        <div className="footer-col cta-col">
          <span className="cta-subtitle">HAVE A PROJECT IN MIND?</span>
          <h4>
            Let’s Build
            <br />
            Something Great
            <br />
            <span>Together.</span>
          </h4>
          <p>Turn your ideas into real-world solutions with our expert team.</p>
          <a href="/contactus" className="cta-button">
            <span>Get in Touch</span>
            <FaArrowRight />
          </a>
        </div>
      </div>

     
      {/* DECORATIVE BACKGROUND */}
      <div className="footer-wave-graphic" aria-hidden="true"></div>

      {/* FOOTER BOTTOM */}
      <div className="footer-bottom">
        <p>© 2026 MindstreamX Technologies. All rights reserved.</p>

        <div className="footer-bottom-links">
          <a href="/privacy-policy">Privacy Policy</a>
          <span className="separator">|</span>
          <a href="/terms-of-service">Terms of Service</a>
          <span className="separator">|</span>
          <a href="/cookie-policy">Cookie Policy</a>

          <button
            type="button"
            onClick={scrollToTop}
            className="scroll-top-btn"
            aria-label="Scroll to top"
          >
            <FaArrowUp />
          </button>
        </div>
      </div>

    </footer>
  );
};

export default FooterSection;
